import { render, staticRenderFns } from "./WorkFlowIndex.vue?vue&type=template&id=009187af&scoped=true&"
import script from "./WorkFlowIndex.vue?vue&type=script&lang=js&"
export * from "./WorkFlowIndex.vue?vue&type=script&lang=js&"
import style0 from "./WorkFlowIndex.vue?vue&type=style&index=0&id=009187af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009187af",
  null
  
)

export default component.exports